/* Homepage */

$(document).ready(function() {

  /* Homepage down arrow anchor on homepage */

  $('.arrow-click').click(function(e){
    e.preventDefault();
    var target = $(this).attr('href');
    var speed = 800;
    var anchor = $('.anchor' + target);
    var header = $('#nav-wrapper');
    $('html, body').animate({scrollTop:anchor.offset().top + header.height() - (($(window).height())/2)}, speed)
  });

  /* Fix sticky position for IOS using stickyfill library on product page and header */

  var mobileSticky = $('.mobile-sticky__block');
  Stickyfill.add(mobileSticky);

  var tabletSticky = $('.sticky__block');
  Stickyfill.add(tabletSticky);

  var headerSticky = $('#nav-wrapper');
  Stickyfill.add(headerSticky);

  /* Order products input quantity */

  $('.js-quantity').each(function(){

    var block = $(this);
    var remove = block.find($('.js-quantity__remove'));
    var add = block.find($('.js-quantity__add'));
    var total = block.find($('.js-quantity__total'));
    var minNumber = 0;
    var maxNumber = parseInt(total.data("max"));

    add.on('click', function(e){
      e.preventDefault();
      if (total.val() == maxNumber){
        return false;
      } else {
        total.val(parseInt(total.val(), 10) + 1);
        total.trigger("change");
      }
    });

    remove.on('click', function(e){
      e.preventDefault();
      if(total.val() == minNumber){
        return false;
      } else {
        total.val( parseInt(total.val(), 10) - 1);
        total.trigger("change");
      }
    });
  });

  /* Back button */

  $('.return-button').on('click', function(){
    window.history.back();
  });

});
